import React from "react";
import { CheckReceipts } from "../../../../presentation/pages/mobile/Check/Receipts";
import { makeDbCheckReceipt } from "../../usecases/check-receipt-factory";
import { makeDbListReceipt } from "../../usecases/list-receipts-factory";
import { makeDbLoadProductList } from "../../usecases/load-product-list-factory";
import { makeDbLoadReceiptCheck } from "../../usecases/load-receipt-check-factory";

export const makeCheckReceipts = () => {
  return (
    <CheckReceipts
      listReceipts={makeDbListReceipt()}
      loadProductList={makeDbLoadProductList()}
      checkReceipt={makeDbCheckReceipt()}
      loadReceiptCheck={makeDbLoadReceiptCheck()}
    />
  );
};
